import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { updation } from './updation.reducer';
import { contribution } from './contribution.reducer';
import { users } from './users.reducer';
import { ingredients } from './ingredients.reducer';
import { recipes } from './recipes.reducer';
import { my_recipes } from './my_recipes.reducer';
import { recipe_image } from './recipe_image.reducer';
import { forgetting } from './forgetting.reducer';
import { alert } from './alert.reducer';
import { communication } from './communication.reducer';

const rootReducer = combineReducers({
  authentication,
  registration,
  updation,
  contribution,
  users,
  ingredients,
  recipes,
  my_recipes,
  recipe_image,
  forgetting,
  communication,
  alert
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/_reducers/index.js